import React, { useEffect, useState } from "react";
import { Table, message } from "antd";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import { useNavigate } from "react-router-dom";


const Enquiries = () => {
  const [bulkEnquiries, setBulkEnquiries] = useState([]);

  // Fetch bulk enquiries from backend
  useEffect(() => {
    const fetchBulkEnquiries = async () => {
      try {
        const response = await axios.get(`${base_url}/api/bulk/bulk-enquiry`);
        setBulkEnquiries(response.data.bulkEnquiries);
        console.log(response.data.bulkEnquiries); // Log the response to inspect
      } catch (error) {
        console.error("Error fetching bulk enquiries:", error);
        message.error("Failed to fetch bulk enquiries.");
      }
    };

    fetchBulkEnquiries();
  }, []);

  // Table columns
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Mobile",
      dataIndex: "phone",
      key: "phone",
    },
    {
  title: "Products Enquired For",
  dataIndex: "products",
  key: "products",
  render: (products) => (
    <div>
      {products?.map((product, index) => (
        <div key={index}>
          {product.product_name} - {product.quantity}
        </div>
      ))}
    </div>
  ),
},

    {
      title: "Creation",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => new Date(createdAt).toLocaleDateString(),
    },
    {
      title: "Additional Notes",
      dataIndex: "additionalNotes",
      key: "additionalNotes",
      render: (additionalNotes) => (
        <span>{additionalNotes || "No additional notes"}</span>
      ),
    },
  ];

  // Table data source
  const dataSource = bulkEnquiries.map((enquiry, index) => ({
    key: index + 1,
    name: enquiry.name,
    email: enquiry.email,
    phone: enquiry.phone,
    products: enquiry.products || [],
    createdAt: enquiry.created_at,
    additionalNotes: enquiry.additional_notes || "",
    id: enquiry.id,
  }));

      
      
      const navigate = useNavigate();

    const adminToken = localStorage.getItem("adminToken");
console.log("Admin Token:", adminToken);

 useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    if (!adminToken) {
      navigate("/");
    }
  }, [navigate]);
      
      
  return (
    <div>
      <h3 className="mb-4 title">Bulk Enquiries</h3>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={{ pageSize: 5 }}
        rowKey="id"
      />
    </div>
  );
};

export default Enquiries;
